import React from 'react';
import { Alert, Box, Button } from '@cloudscape-design/components';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <Box padding="l">
          <Alert
            type="error"
            header="Something went wrong"
            action={
              <Button
                onClick={() => {
                  this.setState({ hasError: false, error: null, errorInfo: null });
                  window.location.reload();
                }}
              >
                Reload Page
              </Button>
            }
          >
            <p>An unexpected error occurred while rendering this component.</p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                <summary>Error Details (Development Mode)</summary>
                <p><strong>Error:</strong> {this.state.error.toString()}</p>
                <p><strong>Stack Trace:</strong></p>
                <pre>{this.state.errorInfo.componentStack}</pre>
              </details>
            )}
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;